import styled from "styled-components";

export const DropAreaWrapper = styled('div')<{isActive: boolean}>`
  position: absolute;
  width: 100%;
  height: 100%;
  ${props=>props.isActive && `
    background-color: rgba(128, 128, 128, 0.1);
  `}
`